import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, Modal, ModalBody} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Add from '@material-ui/icons/Add'
import Paper from "@material-ui/core/Paper";
import Select from "react-select";
import IconButton from "@material-ui/core/IconButton";
import moment from "moment-timezone";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import {Objects} from "../index";
import {Collections} from "../index";
import {HELPDESK_CONTACTED_HIGHLIGHT_EVENT, HELPDESK_CONTACTED_UPDATED_EVENT} from "components/Header/Notifications";

class HelpDesksContacted extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Help_Desks_Contacted._name, 'GET_VIEW');
		model.filter = {};
		super(props, model);
		moment.tz.setDefault("America/Phoenix");
		this.request = 'GET_VIEW';
		this.state.limit = this.props.forHelpdesk ? this.props.contacted_data.length : 40;
		this.state.filter = {};
		this.state.showDate = false;
		const params = new URLSearchParams(
			(props.history && props.history.location && props.history.location.search) || ''
		);
		const dateParam = params.get('date');
		const initialDate = dateParam && moment(dateParam, 'YYYY-MM-DD', true).isValid()
			? moment.tz(dateParam, 'America/Phoenix')
			: moment().tz('America/Phoenix');
		this.state.filterDate = initialDate.format('YYYY-MM-DD');
		this.state.highlightRow = null;
		this.state.page = this.state.page ?? 0;
		this.rowRefs = {};
	}

	onPageChange = (page) => {
		this.setState({page});
	}

	getHighlightPkeyFromLocation = () => {
		const location = this.props.history?.location;
		if (!location) {
			return null;
		}
		const hash = location.hash || '';
		if (hash.includes('?pkey')) {
			const queryString = hash.split('?')[1] || '';
			const params = new URLSearchParams(queryString);
			const pkey = params.get('pkey');
			return pkey != null && pkey !== '' ? Number(pkey) : null;
		}
		const searchParams = new URLSearchParams(location.search || '');
		const searchPkey = searchParams.get('pkey');
		return searchPkey != null && searchPkey !== '' ? Number(searchPkey) : null;
	}

	highlightEngineer = (pkey, data = this.state.data) => {
		if (this.props.forHelpdesk) {
			return;
		}
		const engineerPkey = Number(pkey);
		if (!engineerPkey || Number.isNaN(engineerPkey)) {
			return;
		}

		const rows = Array.isArray(data) ? data : [];
		const matchIndex = rows.findIndex((row) => Number(row.engineer_pkey) === engineerPkey);
		const nextState = {highlightRow: engineerPkey};
		if (matchIndex >= 0 && this.state.limit) {
			nextState.page = Math.floor(matchIndex / this.state.limit);
		}

		this.setState(nextState, () => {
			const row = this.rowRefs[engineerPkey];
			if (row && typeof row.scrollIntoView === 'function') {
				row.scrollIntoView({behavior: 'smooth', block: 'center'});
			}
		});
	}

	applyHighlightFromLocation = (data = this.state.data) => {
		this.highlightEngineer(this.getHighlightPkeyFromLocation(), data);
	}

	handleHighlightEvent = (event) => {
		const pkey = event?.detail?.pkey;
		const date = event?.detail?.date;
		if (date && date !== this.state.filterDate) {
			this.setState({filterDate: date}, async () => {
				await this.getHelpdesksContacted();
				this.highlightEngineer(pkey);
			});
			return;
		}
		this.highlightEngineer(pkey);
	}

	handleContactedUpdated = () => {
		if (this.props.forHelpdesk) {
			return;
		}
		this.getHelpdesksContacted();
		if (this.props.rootState?.triggerAction) {
			this.props.rootState.triggerAction('handleSessionCheck');
		}
	}

	async componentDidMount() {
		window.addEventListener(HELPDESK_CONTACTED_HIGHLIGHT_EVENT, this.handleHighlightEvent);
		window.addEventListener(HELPDESK_CONTACTED_UPDATED_EVENT, this.handleContactedUpdated);
		if (this.props.history?.listen) {
			this.unlistenHistory = this.props.history.listen((location) => {
				const hash = location?.hash || '';
				const dateParam = new URLSearchParams(location?.search || '').get('date');
				if (dateParam && /^\d{4}-\d{2}-\d{2}$/.test(dateParam) && dateParam !== this.state.filterDate) {
					this.setState({filterDate: dateParam}, async () => {
						await this.getHelpdesksContacted();
					});
					return;
				}
				if (hash.includes('?pkey')) {
					this.applyHighlightFromLocation();
				}
			});
		}
	}

	componentWillUnmount() {
		this._leftContacted = true;
		window.removeEventListener(HELPDESK_CONTACTED_HIGHLIGHT_EVENT, this.handleHighlightEvent);
		window.removeEventListener(HELPDESK_CONTACTED_UPDATED_EVENT, this.handleContactedUpdated);
		if (typeof this.unlistenHistory === 'function') {
			this.unlistenHistory();
		}
		if (typeof super.componentWillUnmount === 'function') {
			super.componentWillUnmount();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.highlightRow !== this.state.highlightRow && this.state.highlightRow != null) {
			const row = this.rowRefs[this.state.highlightRow];
			if (row && typeof row.scrollIntoView === 'function') {
				row.scrollIntoView({behavior: 'smooth', block: 'center'});
			}
		}
	}

	getHelpdesksContacted = async () => {
		if (this.props.forHelpdesk) {
			return;
		}
		const seq = (this._contactedSeq || 0) + 1;
		this._contactedSeq = seq;
		let model = new API.BuildClass(Types.Help_Desks_Contacted._name, 'GET_VIEW');
		model.limit = 40;
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		model.filter = {
			'filterDate': this.state.filterDate
		}
		this.setState({loading: true});
		try {
			let data = await model.submit(null, 'GET_VIEW', true);
			if (this._leftContacted || this._contactedSeq !== seq) {
				return;
			}
			this.setState({data, loading: false}, () => {
				this.applyHighlightFromLocation(data);
			});
		} catch (e) {
			if (this._leftContacted || this._contactedSeq !== seq) {
				return;
			}
			this.setState({loading: false});
		}
	}

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	handleDateChange = async (name, date) => {
		this.state.filterDate = moment(date).tz('America/Phoenix').format('YYYY-MM-DD');
		this.handleToggleModal('showDate');
		await this.getHelpdesksContacted();
	}

	fetchData = async (state) => {
		window.setTimeout(() => {
			this.fetchDataActual(state, ['total']);
		}, 100);
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		//this might be broken but i legit can't see how it ever worked when coming from HelpDesks so idk man
		const columns = this.props.forHelpdesk ? [
			{
				Header: "Spoken With",
				id: "helpdesk_agent",
				accessor: obj => obj.notes ? obj.helpdesk_agent ? (obj.helpdesk_name_first + " " + obj.helpdesk_name_last) : 'Admin' : null
			},
			{
				Header: "Notes",
				id: "notes",
				accessor: 'Notes'
			},
			{
				Header: "Field Engineer",
				id: "engineer_pkey",
				accessor: obj => (obj.engineer_name_first + " " + obj.engineer_name_last)
			},
			{
				Header: "Phone Number",
				id: "phone_cell",
				accessor: 'phone_cell'
			}
		] : [
			{
				Header: "Last Spoken With",
				id: "last_agent",
				accessor: obj => obj.last_agent
			},
			{
				Header: "Most Recent Note",
				id: "last_note",
				accessor: 'last_note'
			},
			{
				Header: "Field Engineer",
				id: "engineer_pkey",
				Cell: props => {
					return (
						<span ref={(el) => {
							if (props.original?.engineer_pkey != null) {
								this.rowRefs[props.original.engineer_pkey] = el;
							}
						}}>
							<a href={''} onClick={(event) => {
								event.preventDefault()
								this.setState({contacted_fe: props.original.engineer_pkey, contacted_fe_name: (props.original.fe_name_first + " " + props.original.fe_name_last)})
								this.handleToggleModal('contacted_history');
							}}>
								{(props.original.fe_name_first + " " + props.original.fe_name_last)}
							</a>
						</span>
					);
				}
			},
			{
				Header: "Phone Number",
				id: "phone_cell",
				accessor: 'phone_cell'
			},
			{
				Header: "Today's Avg",
				id: "total_stats_today",
				accessor: 'total_stats_today'
			},
			{
				Header: "7 Day Avg",
				id: "total_stats_7day",
				accessor: 'total_stats_7day'
			},
			{
				Header: "30 Day Avg",
				id: "total_stats_30day",
				accessor: "total_stats_30day",
			},
			{
				Header: "WOs Completed 7 Days",
				id: 'wos_completed_7days',
				accessor: "wos_completed_7days",
			},
			{
				Header: "",
				id: "edit",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				accessor: obj => obj.name,
				Cell: props => {
					return (
						<span data-cy={`add_note_contacted-${props.original.engineer_pkey}`}>
							<Button color="green-meadow" size={"sm"} block={true} onClick={() => {
								this.state.current_note = props.original;
								this.handleToggleModal('help_desk_notes_modal');
							}}>
								<Add fontSize={'small'}/></Button>
						</span>
					);
				}
			},
		]
		return (
			<Card>
				<CardContent>
					{!this.props.forHelpdesk && <div className="table-bar">
						<div className={'row'}>
							<div className={'col-3'} style={{paddingLeft: '15px', paddingRight: '15px'}}>
								{this.renderSearch('Contacted')}
							</div>
							<div className={'col-3'}>
								<div className={"row rbc-toolbar"}>
									<div>
										<IconButton onClick={async () => {
											this.setState({filterDate: moment(this.state.filterDate).tz('America/Phoenix').subtract(1, 'day').format('YYYY-MM-DD')}, async () => {
												await this.getHelpdesksContacted();
											})
										}}><LeftArrowIcon/></IconButton>
										<button className="rbc-today" type="button" onClick={async () => {
											this.setState({filterDate: moment().tz('America/Phoenix').format('YYYY-MM-DD')}, async () => {
												await this.getHelpdesksContacted();
											})
										}}>Today
										</button>
										<IconButton onClick={async () => {
											this.setState({filterDate: moment(this.state.filterDate).tz('America/Phoenix').add(1, 'day').format('YYYY-MM-DD')}, async () => {
												await this.getHelpdesksContacted();
											})
										}}><RightArrowIcon/></IconButton>
									</div>
									<div className={"rbc-toolbar-label"}>
										<label onClick={() => {
											this.handleToggleModal('showDate')
										}}>
											{moment(this.state.filterDate).format('dddd MMM D')}
										</label>
									</div>
								</div>
							</div>
							<div style={{display: 'flex', justifyContent: 'flex-end', alignContent: 'center', flexWrap: 'wrap'}}>
								<Button onClick={async () => {
									await this.getHelpdesksContacted();
								}} size={"sm"} color="primary">
									<i className="fa fa-users"/>Refresh Data
								</Button>
							</div>
						</div>
					</div>}
					<Modal
						isOpen={this.state.showDate}
						toggle={this.toggleClose}
						size={"sm"}
						backdrop={true}
						style={{display: "none"}}
					>
						<ModalBody>
							<Framework.Elements.Date
								label={"Custom Date"}
								value={this.state.filterDate}
								update={this.handleDateChange}
								open={this.state.showDate}
								clearable={false}
								cancelLabel={''}
							/>
						</ModalBody>
					</Modal>

					<Framework.Elements.UniversalModal
						title={"Previous Notes For " + this.state.contacted_fe_name}
						object={Collections.HelpDesksContactedHistory}
						history={this.props.history}
						toggle={this.state.contacted_history}
						reportClose={() => this.handleToggleModal('contacted_history')}
						objectProps={{user: this.state.contacted_fe}}
						hideGoTo={false}
						size={'xl'}
					/>

					<Framework.Elements.UniversalModal
						id={this.state.helpdesksNotePkey ?? null}
						name={"Help Desk Contacted Notes"}
						object={Objects.HelpDesksContacted}
						history={this.props.history}
						toggle={this.state.help_desk_notes_modal}
						reportClose={() => this.handleToggleModal('help_desk_notes_modal')}
						afterSave={async () => {
							await this.getHelpdesksContacted();
							if (this.props.rootState?.triggerAction) {
								this.props.rootState.triggerAction('handleSessionCheck');
							}
						}}
						objectProps={{current_note: this.state.current_note, date_contacted: this.state.filterDate}}
						hideGoTo={true}
					/>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={this.props.contacted_data ?? data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.getHelpdesksContacted} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
						page={this.state.page}
						onPageChange={this.onPageChange}
						getTrProps={(state, rowInfo) => {
							const engineerPkey = rowInfo?.original?.engineer_pkey;
							const highlighted = engineerPkey != null && Number(engineerPkey) === Number(this.state.highlightRow);
							return {
								style: {
									background: highlighted ? '#ffcccc' : undefined,
								},
							};
						}}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}

export default Framework.Components.withRootState(HelpDesksContacted);

